import { gql } from "@apollo/client"
import { InjectedOptions, useMutation } from "@oysterhr/core"
import {
  SetAdpWorkforceNowOnboardingDataInput,
  SetAdpWorkforceNowOnboardingDataPayload,
} from "@oysterhr/schema"
import { TodoTasksTaskFragment } from "~/shared/fragments/TodoTasksTaskFragment"

export const SET_ADP_WORKFORCE_NOW_ONBOARDING_DATA = gql`
  mutation setAdpWorkforceNowOnboardingData(
    $integrationId: ID!
    $engagementId: ID!
    $onboardingTemplateRemoteId: String!
  ) {
    setAdpWorkforceNowOnboardingData(
      input: {
        integrationId: $integrationId
        engagementId: $engagementId
        onboardingTemplateRemoteId: $onboardingTemplateRemoteId
      }
    ) {
      errors
      targetTask {
        ...TodoTasksTaskDetails
      }
    }
  }

  ${TodoTasksTaskFragment}
`

export const useSetAdpWorkforceNowOnboardingData = (
  options?: InjectedOptions<
    {
      setAdpWorkforceNowOnboardingData: SetAdpWorkforceNowOnboardingDataPayload
    },
    SetAdpWorkforceNowOnboardingDataInput
  >,
) => useMutation(SET_ADP_WORKFORCE_NOW_ONBOARDING_DATA, options)
